if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations?.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations?.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}

if (!customElements.get('complementary-recommendations')) {
  customElements.define(
    'complementary-recommendations',
    class ComplementaryRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.recommendationsInitialized === 'true') return;

        this.dataset.recommendationsInitialized = 'true';
        this.setAttribute('aria-busy', 'true');

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.loadRecommendations.bind(this), { timeout: 1500 });
        } else if (window.FoxTheme?.Motion) {
          FoxTheme.Motion.inView(this, this.loadRecommendations.bind(this), { margin: '0px 0px 400px 0px' });
        } else {
          this.loadRecommendations();
        }
      }

      loadRecommendations() {
        if (!this.dataset.url) {
          this.handleError(new Error('Complementary recommendations URL is missing.'));
          return;
        }

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Complementary recommendations request failed: ${response.status}`);
            }
            return response.text();
          })
          .then((responseText) => {
            const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
            const recommendations = responseDocument.querySelector('complementary-recommendations');
            const productCard = recommendations?.querySelector('.complementary-product-card');

            if (!recommendations || !productCard) {
              this.handleEmpty();
              return;
            }

            this.innerHTML = recommendations.innerHTML;
            this.dataset.recommendationsState = 'loaded';
            this.removeAttribute('aria-busy');
            this.dispatchEvent(new CustomEvent('recommendations:loaded', { bubbles: true }));
          })
          .catch((error) => this.handleError(error));
      }

      handleEmpty() {
        const block = this.closest('.product__block--complementary');
        if (block) block.hidden = true;

        this.dataset.recommendationsState = 'empty';
        this.removeAttribute('aria-busy');
        this.dispatchEvent(new CustomEvent('recommendations:empty', { bubbles: true }));
      }

      handleError(error) {
        this.dataset.recommendationsState = 'error';
        this.removeAttribute('aria-busy');
        console.error(error);
      }
    }
  );
}
